// extracted by mini-css-extract-plugin
export default {"container":"MessageTemplates_container__tNYez","header":"MessageTemplates_header__Chgi-"};